"use strict";
// tslint:disable
/**
 * Sendspark API SDK
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = exports.WorspaceResponseSchemaRoleEnum = exports.WorspaceResponseSchemaPlanEnum = exports.UserWorkspaceItemRoleEnum = exports.UserStatusEnum = exports.UserRoleEnum = exports.DefaultCampaignStylesCTAStyleEnum = exports.DefaultCampaignStylesCTATypeEnum = exports.DefaultCampaignStylesPlayButtonStyleEnum = exports.CampaignReactionPayloadTypeEnum = exports.AppSumoNotificationPayloadPlanIdEnum = exports.AppSumoNotificationPayloadActionEnum = void 0;
var globalImportUrl = require("url");
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var base_1 = require("./base");
/**
    * @export
    * @enum {string}
    */
var AppSumoNotificationPayloadActionEnum;
(function (AppSumoNotificationPayloadActionEnum) {
    AppSumoNotificationPayloadActionEnum["Activate"] = "activate";
    AppSumoNotificationPayloadActionEnum["EnhanceTier"] = "enhance_tier";
    AppSumoNotificationPayloadActionEnum["ReduceTier"] = "reduce_tier";
    AppSumoNotificationPayloadActionEnum["Refund"] = "refund";
    AppSumoNotificationPayloadActionEnum["Update"] = "update";
})(AppSumoNotificationPayloadActionEnum = exports.AppSumoNotificationPayloadActionEnum || (exports.AppSumoNotificationPayloadActionEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AppSumoNotificationPayloadPlanIdEnum;
(function (AppSumoNotificationPayloadPlanIdEnum) {
    AppSumoNotificationPayloadPlanIdEnum["Tier1"] = "sendspark_tier1";
    AppSumoNotificationPayloadPlanIdEnum["Tier2"] = "sendspark_tier2";
    AppSumoNotificationPayloadPlanIdEnum["Tier3"] = "sendspark_tier3";
    AppSumoNotificationPayloadPlanIdEnum["Tier4"] = "sendspark_tier4";
    AppSumoNotificationPayloadPlanIdEnum["Tier5"] = "sendspark_tier5";
})(AppSumoNotificationPayloadPlanIdEnum = exports.AppSumoNotificationPayloadPlanIdEnum || (exports.AppSumoNotificationPayloadPlanIdEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CampaignReactionPayloadTypeEnum;
(function (CampaignReactionPayloadTypeEnum) {
    CampaignReactionPayloadTypeEnum["ThumbsUp"] = "thumbsUp";
})(CampaignReactionPayloadTypeEnum = exports.CampaignReactionPayloadTypeEnum || (exports.CampaignReactionPayloadTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var DefaultCampaignStylesPlayButtonStyleEnum;
(function (DefaultCampaignStylesPlayButtonStyleEnum) {
    DefaultCampaignStylesPlayButtonStyleEnum["Solid"] = "solid";
    DefaultCampaignStylesPlayButtonStyleEnum["Outline"] = "outline";
})(DefaultCampaignStylesPlayButtonStyleEnum = exports.DefaultCampaignStylesPlayButtonStyleEnum || (exports.DefaultCampaignStylesPlayButtonStyleEnum = {}));
/**
    * @export
    * @enum {string}
    */
var DefaultCampaignStylesCTATypeEnum;
(function (DefaultCampaignStylesCTATypeEnum) {
    DefaultCampaignStylesCTATypeEnum["Rounded"] = "rounded";
    DefaultCampaignStylesCTATypeEnum["Square"] = "square";
})(DefaultCampaignStylesCTATypeEnum = exports.DefaultCampaignStylesCTATypeEnum || (exports.DefaultCampaignStylesCTATypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var DefaultCampaignStylesCTAStyleEnum;
(function (DefaultCampaignStylesCTAStyleEnum) {
    DefaultCampaignStylesCTAStyleEnum["Solid"] = "solid";
    DefaultCampaignStylesCTAStyleEnum["Outline"] = "outline";
})(DefaultCampaignStylesCTAStyleEnum = exports.DefaultCampaignStylesCTAStyleEnum || (exports.DefaultCampaignStylesCTAStyleEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UserRoleEnum;
(function (UserRoleEnum) {
    UserRoleEnum["Owner"] = "owner";
    UserRoleEnum["Admin"] = "admin";
    UserRoleEnum["Member"] = "member";
    UserRoleEnum["User"] = "user";
})(UserRoleEnum = exports.UserRoleEnum || (exports.UserRoleEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UserStatusEnum;
(function (UserStatusEnum) {
    UserStatusEnum["Pending"] = "pending";
    UserStatusEnum["Active"] = "active";
    UserStatusEnum["Disabled"] = "disabled";
})(UserStatusEnum = exports.UserStatusEnum || (exports.UserStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UserWorkspaceItemRoleEnum;
(function (UserWorkspaceItemRoleEnum) {
    UserWorkspaceItemRoleEnum["Owner"] = "owner";
    UserWorkspaceItemRoleEnum["Admin"] = "admin";
    UserWorkspaceItemRoleEnum["Member"] = "member";
    UserWorkspaceItemRoleEnum["User"] = "user";
})(UserWorkspaceItemRoleEnum = exports.UserWorkspaceItemRoleEnum || (exports.UserWorkspaceItemRoleEnum = {}));
/**
    * @export
    * @enum {string}
    */
var WorspaceResponseSchemaPlanEnum;
(function (WorspaceResponseSchemaPlanEnum) {
    WorspaceResponseSchemaPlanEnum["Free"] = "free";
    WorspaceResponseSchemaPlanEnum["Pro"] = "pro";
    WorspaceResponseSchemaPlanEnum["Custom"] = "custom";
    WorspaceResponseSchemaPlanEnum["SendsparkTier1"] = "sendspark_tier1";
    WorspaceResponseSchemaPlanEnum["SendsparkTier2"] = "sendspark_tier2";
    WorspaceResponseSchemaPlanEnum["SendsparkTier3"] = "sendspark_tier3";
    WorspaceResponseSchemaPlanEnum["SendsparkTier4"] = "sendspark_tier4";
    WorspaceResponseSchemaPlanEnum["SendsparkTier5"] = "sendspark_tier5";
})(WorspaceResponseSchemaPlanEnum = exports.WorspaceResponseSchemaPlanEnum || (exports.WorspaceResponseSchemaPlanEnum = {}));
/**
    * @export
    * @enum {string}
    */
var WorspaceResponseSchemaRoleEnum;
(function (WorspaceResponseSchemaRoleEnum) {
    WorspaceResponseSchemaRoleEnum["Owner"] = "owner";
    WorspaceResponseSchemaRoleEnum["Admin"] = "admin";
    WorspaceResponseSchemaRoleEnum["Member"] = "member";
    WorspaceResponseSchemaRoleEnum["User"] = "user";
})(WorspaceResponseSchemaRoleEnum = exports.WorspaceResponseSchemaRoleEnum || (exports.WorspaceResponseSchemaRoleEnum = {}));
/**
 * DefaultApi - axios parameter creator
 * @export
 */
exports.DefaultApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create Asset for video request
         * @summary Create Asset for video request
         * @param {string} requestId
         * @param {Model2} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVideoRequestAssetByRequestId: function (requestId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'requestId' is not null or undefined
                            if (requestId === null || requestId === undefined) {
                                throw new base_1.RequiredError('requestId', 'Required parameter requestId was null or undefined when calling createVideoRequestAssetByRequestId.');
                            }
                            localVarPath = "/video-request/{requestId}/asset"
                                .replace("{" + "requestId" + "}", encodeURIComponent(String(requestId)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete assets by ID
         * @summary Delete assets Route
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAssetsId: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            if (id === null || id === undefined) {
                                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteAssetsId.');
                            }
                            localVarPath = "/assets/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete the Campaign by the campaignId
         * @summary Delete Campaign By Id Route
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCampaignsId: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            if (id === null || id === undefined) {
                                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteCampaignsId.');
                            }
                            localVarPath = "/campaigns/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete folder by id
         * @summary Folder Delete Route
         * @param {string} folderId
         * @param {Model6} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFoldersFolderid: function (folderId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'folderId' is not null or undefined
                            if (folderId === null || folderId === undefined) {
                                throw new base_1.RequiredError('folderId', 'Required parameter folderId was null or undefined when calling deleteFoldersFolderid.');
                            }
                            localVarPath = "/folders/{folderId}"
                                .replace("{" + "folderId" + "}", encodeURIComponent(String(folderId)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Google login route
         * @summary Google Login Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGoogleLogin: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/google/login";
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete Reaction by ID
         * @summary Delete Reaction Route
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReactionsId: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            if (id === null || id === undefined) {
                                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteReactionsId.');
                            }
                            localVarPath = "/reactions/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete workspace by id
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkspacesWorkspaceid: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling deleteWorkspacesWorkspaceid.');
                            }
                            localVarPath = "/workspaces/{workspaceId}"
                                .replace("{" + "workspaceId" + "}", encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Used for development purposes
         * @summary Get billing provider route
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillingUuid: function (uuid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'uuid' is not null or undefined
                            if (uuid === null || uuid === undefined) {
                                throw new base_1.RequiredError('uuid', 'Required parameter uuid was null or undefined when calling getBillingUuid.');
                            }
                            localVarPath = "/billing/{uuid}"
                                .replace("{" + "uuid" + "}", encodeURIComponent(String(uuid)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a Gif for a campaign
         * @summary Get a Gif for a campaign
         * @param {string} campaignId
         * @param {number} [start]
         * @param {number} [end]
         * @param {string} [width]
         * @param {string} [height]
         * @param {string} [fps]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsCampaignidGif: function (campaignId, start, end, width, height, fps, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling getCampaignsCampaignidGif.');
                            }
                            localVarPath = "/campaigns/{campaignId}/gif"
                                .replace("{" + "campaignId" + "}", encodeURIComponent(String(campaignId)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (start !== undefined) {
                                localVarQueryParameter['start'] = start;
                            }
                            if (end !== undefined) {
                                localVarQueryParameter['end'] = end;
                            }
                            if (width !== undefined) {
                                localVarQueryParameter['width'] = width;
                            }
                            if (height !== undefined) {
                                localVarQueryParameter['height'] = height;
                            }
                            if (fps !== undefined) {
                                localVarQueryParameter['fps'] = fps;
                            }
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get all of the Reactions for a campaign
         * @summary Campaign Reactions Route
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsCampaignidReactions: function (campaignId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling getCampaignsCampaignidReactions.');
                            }
                            localVarPath = "/campaigns/{campaignId}/reactions"
                                .replace("{" + "campaignId" + "}", encodeURIComponent(String(campaignId)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get the Campaign by the campaignId
         * @summary Campaign Get By Id Route
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsId: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            if (id === null || id === undefined) {
                                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling getCampaignsId.');
                            }
                            localVarPath = "/campaigns/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get the Campaign public information by the campaignId
         * @summary Campaign Get By Id Route
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsIdPublic: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            if (id === null || id === undefined) {
                                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling getCampaignsIdPublic.');
                            }
                            localVarPath = "/campaigns/{id}/public"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a oembed json
         * @summary Generate Oembed Service
         * @param {string} url
         * @param {string} [queryParam]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsOembed: function (url, queryParam, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'url' is not null or undefined
                            if (url === null || url === undefined) {
                                throw new base_1.RequiredError('url', 'Required parameter url was null or undefined when calling getCampaignsOembed.');
                            }
                            localVarPath = "/campaigns/oembed";
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (url !== undefined) {
                                localVarQueryParameter['url'] = url;
                            }
                            if (queryParam !== undefined) {
                                localVarQueryParameter['queryParam'] = queryParam;
                            }
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get all campaign templates by a folder id
         * @summary Campaigns Templates Route
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsTemplates: function (offset, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/campaigns/templates";
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get all of the campaigns by a folder id
         * @summary Folders Route
         * @param {string} folderId
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFoldersFolderidCampaigns: function (folderId, offset, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'folderId' is not null or undefined
                            if (folderId === null || folderId === undefined) {
                                throw new base_1.RequiredError('folderId', 'Required parameter folderId was null or undefined when calling getFoldersFolderidCampaigns.');
                            }
                            localVarPath = "/folders/{folderId}/campaigns"
                                .replace("{" + "folderId" + "}", encodeURIComponent(String(folderId)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get all of the folders belongs to a user
         * @summary Folders Route
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFoldersWorkspaceid: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getFoldersWorkspaceid.');
                            }
                            localVarPath = "/folders/{workspaceId}"
                                .replace("{" + "workspaceId" + "}", encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Google login route
         * @summary Google Login Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGoogleLogin: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/google/login";
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a health message
         * @summary Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealth: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/health";
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This route delete the cookie for the users session
         * @summary Logout Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogout: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/logout";
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get all of the Reactions
         * @summary Reactions Route
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReactionsId: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            if (id === null || id === undefined) {
                                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling getReactionsId.');
                            }
                            localVarPath = "/reactions/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * GET current user route
         * @summary Get your current user route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/users";
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get the Campaign by the requestId
         * @summary Get Campaign By request id Route
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVideoRequestByRequestId: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            if (id === null || id === undefined) {
                                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling getVideoRequestByRequestId.');
                            }
                            localVarPath = "/video-request/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns stats of the workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceStats: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getWorkspaceStats.');
                            }
                            localVarPath = "/workspaces/{workspaceId}/stats"
                                .replace("{" + "workspaceId" + "}", encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the list of the current users workspaces
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaces: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/workspaces";
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get workspace by id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesId: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            if (id === null || id === undefined) {
                                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling getWorkspacesId.');
                            }
                            localVarPath = "/workspaces/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Optionally we can pass the userId, it will default to currentUser
         * @summary Get the current users workspace settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesSettings: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/workspaces/settings";
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the legacy current users workspace usage.
         * @param {'all' | 'videos' | 'users'} usageType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesUsage: function (usageType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'usageType' is not null or undefined
                            if (usageType === null || usageType === undefined) {
                                throw new base_1.RequiredError('usageType', 'Required parameter usageType was null or undefined when calling getWorkspacesUsage.');
                            }
                            localVarPath = "/workspaces/usage";
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (usageType !== undefined) {
                                localVarQueryParameter['usageType'] = usageType;
                            }
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the list of the assets
         * @param {string} workspaceId
         * @param {string} [folder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesWorkspaceidAssets: function (workspaceId, folder, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getWorkspacesWorkspaceidAssets.');
                            }
                            localVarPath = "/workspaces/{workspaceId}/assets"
                                .replace("{" + "workspaceId" + "}", encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (folder !== undefined) {
                                localVarQueryParameter['folder'] = folder;
                            }
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns stats of the workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesWorkspaceidCreatedvideos: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getWorkspacesWorkspaceidCreatedvideos.');
                            }
                            localVarPath = "/workspaces/{workspaceId}/created-videos"
                                .replace("{" + "workspaceId" + "}", encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns stats of the workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesWorkspaceidCreatedvideosv2: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getWorkspacesWorkspaceidCreatedvideosv2.');
                            }
                            localVarPath = "/workspaces/{workspaceId}/created-videos-v2"
                                .replace("{" + "workspaceId" + "}", encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns stats of the workspace
         * @param {string} workspaceId
         * @param {number} usersNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesWorkspaceidTopvideosUsersnumber: function (workspaceId, usersNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getWorkspacesWorkspaceidTopvideosUsersnumber.');
                            }
                            // verify required parameter 'usersNumber' is not null or undefined
                            if (usersNumber === null || usersNumber === undefined) {
                                throw new base_1.RequiredError('usersNumber', 'Required parameter usersNumber was null or undefined when calling getWorkspacesWorkspaceidTopvideosUsersnumber.');
                            }
                            localVarPath = "/workspaces/{workspaceId}/top-videos/{usersNumber}"
                                .replace("{" + "workspaceId" + "}", encodeURIComponent(String(workspaceId)))
                                .replace("{" + "usersNumber" + "}", encodeURIComponent(String(usersNumber)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a campaign By Id Route
         * @param {string} id
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaignsId: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            if (id === null || id === undefined) {
                                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling patchCampaignsId.');
                            }
                            localVarPath = "/campaigns/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Google login route
         * @summary Google Login Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchGoogleLogin: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/google/login";
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Add additional features to workspace by owners
         * @param {'storage' | 'workspaces' | 'videos' | 'creators'} feature
         * @param {'double'} value
         * @param {WorkspaceAdditionalFeaturesSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspacesAdditionalfeatures: function (feature, value, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'feature' is not null or undefined
                            if (feature === null || feature === undefined) {
                                throw new base_1.RequiredError('feature', 'Required parameter feature was null or undefined when calling patchWorkspacesAdditionalfeatures.');
                            }
                            // verify required parameter 'value' is not null or undefined
                            if (value === null || value === undefined) {
                                throw new base_1.RequiredError('value', 'Required parameter value was null or undefined when calling patchWorkspacesAdditionalfeatures.');
                            }
                            localVarPath = "/workspaces/additional-features";
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (feature !== undefined) {
                                localVarQueryParameter['feature'] = feature;
                            }
                            if (value !== undefined) {
                                localVarQueryParameter['value'] = value;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get workspace by id
         * @param {string} id
         * @param {Model10} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspacesId: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            if (id === null || id === undefined) {
                                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling patchWorkspacesId.');
                            }
                            localVarPath = "/workspaces/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Replace the current users last visited workspace with the id provided.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspacesIdChange: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            if (id === null || id === undefined) {
                                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling patchWorkspacesIdChange.');
                            }
                            localVarPath = "/workspaces/{id}/change"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Generate a valid JWT for our AppSumo intergration
         * @summary Returns a valid JWT for AppSumo intergration
         * @param {AppSumoLoginPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAppsumoAuthLogin: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/appsumo/auth/login";
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * When a Sumo-ling buys interacts with our license, we get a notification
         * @summary AppSumo notifications
         * @param {AppSumoNotificationPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAppsumoWebhookNotification: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/appsumo/webhook/notification";
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create assets
         * @summary Create assets Route
         * @param {Model2} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAssets: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/assets";
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Forgot Password Route
         * @param {ForgotPasswordPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAuthForgotpassword: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/auth/forgot-password";
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create Campaign in folder
         * @summary Create Campaign
         * @param {string} folderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCampaign: function (folderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'folderId' is not null or undefined
                            if (folderId === null || folderId === undefined) {
                                throw new base_1.RequiredError('folderId', 'Required parameter folderId was null or undefined when calling postCampaign.');
                            }
                            localVarPath = "/campaigns/{folderId}"
                                .replace("{" + "folderId" + "}", encodeURIComponent(String(folderId)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create a new Reaction to a Campaign Video
         * @summary Create a new Reaction
         * @param {string} campaignId
         * @param {CampaignReactionPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCampaignsCampaignidReactions: function (campaignId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling postCampaignsCampaignidReactions.');
                            }
                            localVarPath = "/campaigns/{campaignId}/reactions"
                                .replace("{" + "campaignId" + "}", encodeURIComponent(String(campaignId)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get the Campaign by the campaignId
         * @summary Duplicate Campaign
         * @param {string} campaignId
         * @param {Model5} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCampaignsDuplicate: function (campaignId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling postCampaignsDuplicate.');
                            }
                            localVarPath = "/campaigns/{campaignId}/duplicate"
                                .replace("{" + "campaignId" + "}", encodeURIComponent(String(campaignId)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create a new Campaign based on a Template
         * @summary Create a new Campaign based on a Template
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCampaignsUseTemplate: function (campaignId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling postCampaignsUseTemplate.');
                            }
                            localVarPath = "/campaigns/{campaignId}/use-template"
                                .replace("{" + "campaignId" + "}", encodeURIComponent(String(campaignId)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This receive an open object that containts the data we have to track
         * @summary Sendspark event to track user activity
         * @param {EventPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEvents: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/events";
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Google login route
         * @summary Google Login Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postGoogleLogin: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/google/login";
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * User Login Route that returns a valid JTW
         * @summary Login Route
         * @param {LoginPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLogin: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/login";
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Being used for websockets to push events to the frontend.
         * @summary Webhook to get an event when an the asset is ready.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMuxWebhookVideoready: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/mux/webhook/video-ready";
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Request a new Video Campaign for the workspace passed as parameter
         * @summary Request Video Campaign
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRequestCampaign: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postRequestCampaign.');
                            }
                            localVarPath = "/campaigns/{workspaceId}/request-video"
                                .replace("{" + "workspaceId" + "}", encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Add meeting links for the user passed as parameter
         * @summary Create meeting links for user
         * @param {string} userId
         * @param {UsersMeetingLinksPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUsersMeetingLinks: function (userId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'userId' is not null or undefined
                            if (userId === null || userId === undefined) {
                                throw new base_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling postUsersMeetingLinks.');
                            }
                            localVarPath = "/users/{userId}/meeting-links"
                                .replace("{" + "userId" + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Optionally we can pass the userId, it will default to currentUser
         * @summary Create a new workspace
         * @param {CreateWorkspaceResponseSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkspaces: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/workspaces";
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * We need pass the emails to invite to this route
         * @summary Workspace invite route
         * @param {string} workspaceId
         * @param {WorkspaceInvitePayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkspacesWorkspaceidInvite: function (workspaceId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postWorkspacesWorkspaceidInvite.');
                            }
                            localVarPath = "/workspaces/{workspaceId}/invite"
                                .replace("{" + "workspaceId" + "}", encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Completes the activation for appsumo packages.
         * @param {AppSumoActivationPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAppsumoActivation: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/appsumo/activation";
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update asset mime type
         * @summary Update mime type for an asset
         * @param {string} id
         * @param {Model9} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAssetsIdMime: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            if (id === null || id === undefined) {
                                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling putAssetsIdMime.');
                            }
                            localVarPath = "/assets/{id}/mime"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Google login route
         * @summary Google Login Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putGoogleLogin: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/google/login";
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a campaign By Request Id Route
         * @param {string} requestId
         * @param {VideoRequestPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVideoRequestById: function (requestId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'requestId' is not null or undefined
                            if (requestId === null || requestId === undefined) {
                                throw new base_1.RequiredError('requestId', 'Required parameter requestId was null or undefined when calling putVideoRequestById.');
                            }
                            localVarPath = "/video-request/{requestId}"
                                .replace("{" + "requestId" + "}", encodeURIComponent(String(requestId)));
                            localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                            delete localVarUrlObj.search;
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: globalImportUrl.format(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * DefaultApi - functional programming interface
 * @export
 */
exports.DefaultApiFp = function (configuration) {
    return {
        /**
         * Create Asset for video request
         * @summary Create Asset for video request
         * @param {string} requestId
         * @param {Model2} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVideoRequestAssetByRequestId: function (requestId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).createVideoRequestAssetByRequestId(requestId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Delete assets by ID
         * @summary Delete assets Route
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAssetsId: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).deleteAssetsId(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Delete the Campaign by the campaignId
         * @summary Delete Campaign By Id Route
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCampaignsId: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).deleteCampaignsId(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Delete folder by id
         * @summary Folder Delete Route
         * @param {string} folderId
         * @param {Model6} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFoldersFolderid: function (folderId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).deleteFoldersFolderid(folderId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Google login route
         * @summary Google Login Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGoogleLogin: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).deleteGoogleLogin(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Delete Reaction by ID
         * @summary Delete Reaction Route
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReactionsId: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).deleteReactionsId(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete workspace by id
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkspacesWorkspaceid: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).deleteWorkspacesWorkspaceid(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Used for development purposes
         * @summary Get billing provider route
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillingUuid: function (uuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).getBillingUuid(uuid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get a Gif for a campaign
         * @summary Get a Gif for a campaign
         * @param {string} campaignId
         * @param {number} [start]
         * @param {number} [end]
         * @param {string} [width]
         * @param {string} [height]
         * @param {string} [fps]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsCampaignidGif: function (campaignId, start, end, width, height, fps, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).getCampaignsCampaignidGif(campaignId, start, end, width, height, fps, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get all of the Reactions for a campaign
         * @summary Campaign Reactions Route
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsCampaignidReactions: function (campaignId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).getCampaignsCampaignidReactions(campaignId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get the Campaign by the campaignId
         * @summary Campaign Get By Id Route
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsId: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).getCampaignsId(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get the Campaign public information by the campaignId
         * @summary Campaign Get By Id Route
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsIdPublic: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).getCampaignsIdPublic(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Returns a oembed json
         * @summary Generate Oembed Service
         * @param {string} url
         * @param {string} [queryParam]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsOembed: function (url, queryParam, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).getCampaignsOembed(url, queryParam, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get all campaign templates by a folder id
         * @summary Campaigns Templates Route
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsTemplates: function (offset, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).getCampaignsTemplates(offset, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get all of the campaigns by a folder id
         * @summary Folders Route
         * @param {string} folderId
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFoldersFolderidCampaigns: function (folderId, offset, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).getFoldersFolderidCampaigns(folderId, offset, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get all of the folders belongs to a user
         * @summary Folders Route
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFoldersWorkspaceid: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).getFoldersWorkspaceid(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Google login route
         * @summary Google Login Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGoogleLogin: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).getGoogleLogin(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Returns a health message
         * @summary Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealth: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).getHealth(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * This route delete the cookie for the users session
         * @summary Logout Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogout: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).getLogout(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get all of the Reactions
         * @summary Reactions Route
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReactionsId: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).getReactionsId(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * GET current user route
         * @summary Get your current user route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).getUsers(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get the Campaign by the requestId
         * @summary Get Campaign By request id Route
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVideoRequestByRequestId: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).getVideoRequestByRequestId(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns stats of the workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceStats: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).getWorkspaceStats(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the list of the current users workspaces
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaces: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).getWorkspaces(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get workspace by id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesId: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).getWorkspacesId(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Optionally we can pass the userId, it will default to currentUser
         * @summary Get the current users workspace settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesSettings: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).getWorkspacesSettings(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the legacy current users workspace usage.
         * @param {'all' | 'videos' | 'users'} usageType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesUsage: function (usageType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).getWorkspacesUsage(usageType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the list of the assets
         * @param {string} workspaceId
         * @param {string} [folder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesWorkspaceidAssets: function (workspaceId, folder, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).getWorkspacesWorkspaceidAssets(workspaceId, folder, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns stats of the workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesWorkspaceidCreatedvideos: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).getWorkspacesWorkspaceidCreatedvideos(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns stats of the workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesWorkspaceidCreatedvideosv2: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).getWorkspacesWorkspaceidCreatedvideosv2(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns stats of the workspace
         * @param {string} workspaceId
         * @param {number} usersNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesWorkspaceidTopvideosUsersnumber: function (workspaceId, usersNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).getWorkspacesWorkspaceidTopvideosUsersnumber(workspaceId, usersNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a campaign By Id Route
         * @param {string} id
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaignsId: function (id, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).patchCampaignsId(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Google login route
         * @summary Google Login Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchGoogleLogin: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).patchGoogleLogin(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Add additional features to workspace by owners
         * @param {'storage' | 'workspaces' | 'videos' | 'creators'} feature
         * @param {'double'} value
         * @param {WorkspaceAdditionalFeaturesSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspacesAdditionalfeatures: function (feature, value, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).patchWorkspacesAdditionalfeatures(feature, value, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get workspace by id
         * @param {string} id
         * @param {Model10} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspacesId: function (id, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).patchWorkspacesId(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Replace the current users last visited workspace with the id provided.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspacesIdChange: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).patchWorkspacesIdChange(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Generate a valid JWT for our AppSumo intergration
         * @summary Returns a valid JWT for AppSumo intergration
         * @param {AppSumoLoginPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAppsumoAuthLogin: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).postAppsumoAuthLogin(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * When a Sumo-ling buys interacts with our license, we get a notification
         * @summary AppSumo notifications
         * @param {AppSumoNotificationPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAppsumoWebhookNotification: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).postAppsumoWebhookNotification(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Create assets
         * @summary Create assets Route
         * @param {Model2} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAssets: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).postAssets(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Forgot Password Route
         * @param {ForgotPasswordPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAuthForgotpassword: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).postAuthForgotpassword(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Create Campaign in folder
         * @summary Create Campaign
         * @param {string} folderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCampaign: function (folderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).postCampaign(folderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Create a new Reaction to a Campaign Video
         * @summary Create a new Reaction
         * @param {string} campaignId
         * @param {CampaignReactionPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCampaignsCampaignidReactions: function (campaignId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).postCampaignsCampaignidReactions(campaignId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get the Campaign by the campaignId
         * @summary Duplicate Campaign
         * @param {string} campaignId
         * @param {Model5} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCampaignsDuplicate: function (campaignId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).postCampaignsDuplicate(campaignId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Create a new Campaign based on a Template
         * @summary Create a new Campaign based on a Template
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCampaignsUseTemplate: function (campaignId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).postCampaignsUseTemplate(campaignId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * This receive an open object that containts the data we have to track
         * @summary Sendspark event to track user activity
         * @param {EventPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEvents: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).postEvents(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Google login route
         * @summary Google Login Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postGoogleLogin: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).postGoogleLogin(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * User Login Route that returns a valid JTW
         * @summary Login Route
         * @param {LoginPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLogin: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).postLogin(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Being used for websockets to push events to the frontend.
         * @summary Webhook to get an event when an the asset is ready.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMuxWebhookVideoready: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).postMuxWebhookVideoready(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Request a new Video Campaign for the workspace passed as parameter
         * @summary Request Video Campaign
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRequestCampaign: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).postRequestCampaign(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Add meeting links for the user passed as parameter
         * @summary Create meeting links for user
         * @param {string} userId
         * @param {UsersMeetingLinksPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUsersMeetingLinks: function (userId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).postUsersMeetingLinks(userId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Optionally we can pass the userId, it will default to currentUser
         * @summary Create a new workspace
         * @param {CreateWorkspaceResponseSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkspaces: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).postWorkspaces(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * We need pass the emails to invite to this route
         * @summary Workspace invite route
         * @param {string} workspaceId
         * @param {WorkspaceInvitePayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkspacesWorkspaceidInvite: function (workspaceId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).postWorkspacesWorkspaceidInvite(workspaceId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Completes the activation for appsumo packages.
         * @param {AppSumoActivationPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAppsumoActivation: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).putAppsumoActivation(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Update asset mime type
         * @summary Update mime type for an asset
         * @param {string} id
         * @param {Model9} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAssetsIdMime: function (id, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).putAssetsIdMime(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Google login route
         * @summary Google Login Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putGoogleLogin: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).putGoogleLogin(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a campaign By Request Id Route
         * @param {string} requestId
         * @param {VideoRequestPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVideoRequestById: function (requestId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.DefaultApiAxiosParamCreator(configuration).putVideoRequestById(requestId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * DefaultApi - factory interface
 * @export
 */
exports.DefaultApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * Create Asset for video request
         * @summary Create Asset for video request
         * @param {string} requestId
         * @param {Model2} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVideoRequestAssetByRequestId: function (requestId, body, options) {
            return exports.DefaultApiFp(configuration).createVideoRequestAssetByRequestId(requestId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete assets by ID
         * @summary Delete assets Route
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAssetsId: function (id, options) {
            return exports.DefaultApiFp(configuration).deleteAssetsId(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete the Campaign by the campaignId
         * @summary Delete Campaign By Id Route
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCampaignsId: function (id, options) {
            return exports.DefaultApiFp(configuration).deleteCampaignsId(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete folder by id
         * @summary Folder Delete Route
         * @param {string} folderId
         * @param {Model6} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFoldersFolderid: function (folderId, body, options) {
            return exports.DefaultApiFp(configuration).deleteFoldersFolderid(folderId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Google login route
         * @summary Google Login Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGoogleLogin: function (options) {
            return exports.DefaultApiFp(configuration).deleteGoogleLogin(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete Reaction by ID
         * @summary Delete Reaction Route
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReactionsId: function (id, options) {
            return exports.DefaultApiFp(configuration).deleteReactionsId(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete workspace by id
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkspacesWorkspaceid: function (workspaceId, options) {
            return exports.DefaultApiFp(configuration).deleteWorkspacesWorkspaceid(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Used for development purposes
         * @summary Get billing provider route
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillingUuid: function (uuid, options) {
            return exports.DefaultApiFp(configuration).getBillingUuid(uuid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a Gif for a campaign
         * @summary Get a Gif for a campaign
         * @param {string} campaignId
         * @param {number} [start]
         * @param {number} [end]
         * @param {string} [width]
         * @param {string} [height]
         * @param {string} [fps]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsCampaignidGif: function (campaignId, start, end, width, height, fps, options) {
            return exports.DefaultApiFp(configuration).getCampaignsCampaignidGif(campaignId, start, end, width, height, fps, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all of the Reactions for a campaign
         * @summary Campaign Reactions Route
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsCampaignidReactions: function (campaignId, options) {
            return exports.DefaultApiFp(configuration).getCampaignsCampaignidReactions(campaignId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the Campaign by the campaignId
         * @summary Campaign Get By Id Route
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsId: function (id, options) {
            return exports.DefaultApiFp(configuration).getCampaignsId(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the Campaign public information by the campaignId
         * @summary Campaign Get By Id Route
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsIdPublic: function (id, options) {
            return exports.DefaultApiFp(configuration).getCampaignsIdPublic(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a oembed json
         * @summary Generate Oembed Service
         * @param {string} url
         * @param {string} [queryParam]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsOembed: function (url, queryParam, options) {
            return exports.DefaultApiFp(configuration).getCampaignsOembed(url, queryParam, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all campaign templates by a folder id
         * @summary Campaigns Templates Route
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsTemplates: function (offset, limit, options) {
            return exports.DefaultApiFp(configuration).getCampaignsTemplates(offset, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all of the campaigns by a folder id
         * @summary Folders Route
         * @param {string} folderId
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFoldersFolderidCampaigns: function (folderId, offset, limit, options) {
            return exports.DefaultApiFp(configuration).getFoldersFolderidCampaigns(folderId, offset, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all of the folders belongs to a user
         * @summary Folders Route
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFoldersWorkspaceid: function (workspaceId, options) {
            return exports.DefaultApiFp(configuration).getFoldersWorkspaceid(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Google login route
         * @summary Google Login Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGoogleLogin: function (options) {
            return exports.DefaultApiFp(configuration).getGoogleLogin(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a health message
         * @summary Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealth: function (options) {
            return exports.DefaultApiFp(configuration).getHealth(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This route delete the cookie for the users session
         * @summary Logout Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogout: function (options) {
            return exports.DefaultApiFp(configuration).getLogout(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all of the Reactions
         * @summary Reactions Route
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReactionsId: function (id, options) {
            return exports.DefaultApiFp(configuration).getReactionsId(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * GET current user route
         * @summary Get your current user route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: function (options) {
            return exports.DefaultApiFp(configuration).getUsers(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the Campaign by the requestId
         * @summary Get Campaign By request id Route
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVideoRequestByRequestId: function (id, options) {
            return exports.DefaultApiFp(configuration).getVideoRequestByRequestId(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns stats of the workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceStats: function (workspaceId, options) {
            return exports.DefaultApiFp(configuration).getWorkspaceStats(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get the list of the current users workspaces
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaces: function (options) {
            return exports.DefaultApiFp(configuration).getWorkspaces(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get workspace by id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesId: function (id, options) {
            return exports.DefaultApiFp(configuration).getWorkspacesId(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Optionally we can pass the userId, it will default to currentUser
         * @summary Get the current users workspace settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesSettings: function (options) {
            return exports.DefaultApiFp(configuration).getWorkspacesSettings(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get the legacy current users workspace usage.
         * @param {'all' | 'videos' | 'users'} usageType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesUsage: function (usageType, options) {
            return exports.DefaultApiFp(configuration).getWorkspacesUsage(usageType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get the list of the assets
         * @param {string} workspaceId
         * @param {string} [folder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesWorkspaceidAssets: function (workspaceId, folder, options) {
            return exports.DefaultApiFp(configuration).getWorkspacesWorkspaceidAssets(workspaceId, folder, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns stats of the workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesWorkspaceidCreatedvideos: function (workspaceId, options) {
            return exports.DefaultApiFp(configuration).getWorkspacesWorkspaceidCreatedvideos(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns stats of the workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesWorkspaceidCreatedvideosv2: function (workspaceId, options) {
            return exports.DefaultApiFp(configuration).getWorkspacesWorkspaceidCreatedvideosv2(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns stats of the workspace
         * @param {string} workspaceId
         * @param {number} usersNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesWorkspaceidTopvideosUsersnumber: function (workspaceId, usersNumber, options) {
            return exports.DefaultApiFp(configuration).getWorkspacesWorkspaceidTopvideosUsersnumber(workspaceId, usersNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a campaign By Id Route
         * @param {string} id
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaignsId: function (id, body, options) {
            return exports.DefaultApiFp(configuration).patchCampaignsId(id, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Google login route
         * @summary Google Login Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchGoogleLogin: function (options) {
            return exports.DefaultApiFp(configuration).patchGoogleLogin(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Add additional features to workspace by owners
         * @param {'storage' | 'workspaces' | 'videos' | 'creators'} feature
         * @param {'double'} value
         * @param {WorkspaceAdditionalFeaturesSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspacesAdditionalfeatures: function (feature, value, body, options) {
            return exports.DefaultApiFp(configuration).patchWorkspacesAdditionalfeatures(feature, value, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get workspace by id
         * @param {string} id
         * @param {Model10} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspacesId: function (id, body, options) {
            return exports.DefaultApiFp(configuration).patchWorkspacesId(id, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Replace the current users last visited workspace with the id provided.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspacesIdChange: function (id, options) {
            return exports.DefaultApiFp(configuration).patchWorkspacesIdChange(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Generate a valid JWT for our AppSumo intergration
         * @summary Returns a valid JWT for AppSumo intergration
         * @param {AppSumoLoginPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAppsumoAuthLogin: function (body, options) {
            return exports.DefaultApiFp(configuration).postAppsumoAuthLogin(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * When a Sumo-ling buys interacts with our license, we get a notification
         * @summary AppSumo notifications
         * @param {AppSumoNotificationPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAppsumoWebhookNotification: function (body, options) {
            return exports.DefaultApiFp(configuration).postAppsumoWebhookNotification(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create assets
         * @summary Create assets Route
         * @param {Model2} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAssets: function (body, options) {
            return exports.DefaultApiFp(configuration).postAssets(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Forgot Password Route
         * @param {ForgotPasswordPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAuthForgotpassword: function (body, options) {
            return exports.DefaultApiFp(configuration).postAuthForgotpassword(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create Campaign in folder
         * @summary Create Campaign
         * @param {string} folderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCampaign: function (folderId, options) {
            return exports.DefaultApiFp(configuration).postCampaign(folderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a new Reaction to a Campaign Video
         * @summary Create a new Reaction
         * @param {string} campaignId
         * @param {CampaignReactionPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCampaignsCampaignidReactions: function (campaignId, body, options) {
            return exports.DefaultApiFp(configuration).postCampaignsCampaignidReactions(campaignId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the Campaign by the campaignId
         * @summary Duplicate Campaign
         * @param {string} campaignId
         * @param {Model5} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCampaignsDuplicate: function (campaignId, body, options) {
            return exports.DefaultApiFp(configuration).postCampaignsDuplicate(campaignId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a new Campaign based on a Template
         * @summary Create a new Campaign based on a Template
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCampaignsUseTemplate: function (campaignId, options) {
            return exports.DefaultApiFp(configuration).postCampaignsUseTemplate(campaignId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This receive an open object that containts the data we have to track
         * @summary Sendspark event to track user activity
         * @param {EventPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEvents: function (body, options) {
            return exports.DefaultApiFp(configuration).postEvents(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Google login route
         * @summary Google Login Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postGoogleLogin: function (options) {
            return exports.DefaultApiFp(configuration).postGoogleLogin(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * User Login Route that returns a valid JTW
         * @summary Login Route
         * @param {LoginPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLogin: function (body, options) {
            return exports.DefaultApiFp(configuration).postLogin(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Being used for websockets to push events to the frontend.
         * @summary Webhook to get an event when an the asset is ready.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMuxWebhookVideoready: function (options) {
            return exports.DefaultApiFp(configuration).postMuxWebhookVideoready(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Request a new Video Campaign for the workspace passed as parameter
         * @summary Request Video Campaign
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRequestCampaign: function (workspaceId, options) {
            return exports.DefaultApiFp(configuration).postRequestCampaign(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Add meeting links for the user passed as parameter
         * @summary Create meeting links for user
         * @param {string} userId
         * @param {UsersMeetingLinksPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUsersMeetingLinks: function (userId, body, options) {
            return exports.DefaultApiFp(configuration).postUsersMeetingLinks(userId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Optionally we can pass the userId, it will default to currentUser
         * @summary Create a new workspace
         * @param {CreateWorkspaceResponseSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkspaces: function (body, options) {
            return exports.DefaultApiFp(configuration).postWorkspaces(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * We need pass the emails to invite to this route
         * @summary Workspace invite route
         * @param {string} workspaceId
         * @param {WorkspaceInvitePayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkspacesWorkspaceidInvite: function (workspaceId, body, options) {
            return exports.DefaultApiFp(configuration).postWorkspacesWorkspaceidInvite(workspaceId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Completes the activation for appsumo packages.
         * @param {AppSumoActivationPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAppsumoActivation: function (body, options) {
            return exports.DefaultApiFp(configuration).putAppsumoActivation(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update asset mime type
         * @summary Update mime type for an asset
         * @param {string} id
         * @param {Model9} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAssetsIdMime: function (id, body, options) {
            return exports.DefaultApiFp(configuration).putAssetsIdMime(id, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Google login route
         * @summary Google Login Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putGoogleLogin: function (options) {
            return exports.DefaultApiFp(configuration).putGoogleLogin(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a campaign By Request Id Route
         * @param {string} requestId
         * @param {VideoRequestPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVideoRequestById: function (requestId, body, options) {
            return exports.DefaultApiFp(configuration).putVideoRequestById(requestId, body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
var DefaultApi = /** @class */ (function (_super) {
    __extends(DefaultApi, _super);
    function DefaultApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create Asset for video request
     * @summary Create Asset for video request
     * @param {string} requestId
     * @param {Model2} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.createVideoRequestAssetByRequestId = function (requestId, body, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).createVideoRequestAssetByRequestId(requestId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete assets by ID
     * @summary Delete assets Route
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteAssetsId = function (id, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).deleteAssetsId(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete the Campaign by the campaignId
     * @summary Delete Campaign By Id Route
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteCampaignsId = function (id, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).deleteCampaignsId(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete folder by id
     * @summary Folder Delete Route
     * @param {string} folderId
     * @param {Model6} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteFoldersFolderid = function (folderId, body, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).deleteFoldersFolderid(folderId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Google login route
     * @summary Google Login Route
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteGoogleLogin = function (options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).deleteGoogleLogin(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete Reaction by ID
     * @summary Delete Reaction Route
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteReactionsId = function (id, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).deleteReactionsId(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete workspace by id
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteWorkspacesWorkspaceid = function (workspaceId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).deleteWorkspacesWorkspaceid(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Used for development purposes
     * @summary Get billing provider route
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getBillingUuid = function (uuid, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getBillingUuid(uuid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a Gif for a campaign
     * @summary Get a Gif for a campaign
     * @param {string} campaignId
     * @param {number} [start]
     * @param {number} [end]
     * @param {string} [width]
     * @param {string} [height]
     * @param {string} [fps]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCampaignsCampaignidGif = function (campaignId, start, end, width, height, fps, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getCampaignsCampaignidGif(campaignId, start, end, width, height, fps, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all of the Reactions for a campaign
     * @summary Campaign Reactions Route
     * @param {string} campaignId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCampaignsCampaignidReactions = function (campaignId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getCampaignsCampaignidReactions(campaignId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the Campaign by the campaignId
     * @summary Campaign Get By Id Route
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCampaignsId = function (id, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getCampaignsId(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the Campaign public information by the campaignId
     * @summary Campaign Get By Id Route
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCampaignsIdPublic = function (id, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getCampaignsIdPublic(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a oembed json
     * @summary Generate Oembed Service
     * @param {string} url
     * @param {string} [queryParam]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCampaignsOembed = function (url, queryParam, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getCampaignsOembed(url, queryParam, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all campaign templates by a folder id
     * @summary Campaigns Templates Route
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCampaignsTemplates = function (offset, limit, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getCampaignsTemplates(offset, limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all of the campaigns by a folder id
     * @summary Folders Route
     * @param {string} folderId
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getFoldersFolderidCampaigns = function (folderId, offset, limit, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getFoldersFolderidCampaigns(folderId, offset, limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all of the folders belongs to a user
     * @summary Folders Route
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getFoldersWorkspaceid = function (workspaceId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getFoldersWorkspaceid(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Google login route
     * @summary Google Login Route
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getGoogleLogin = function (options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getGoogleLogin(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a health message
     * @summary Health
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getHealth = function (options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getHealth(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This route delete the cookie for the users session
     * @summary Logout Route
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getLogout = function (options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getLogout(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all of the Reactions
     * @summary Reactions Route
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getReactionsId = function (id, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getReactionsId(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * GET current user route
     * @summary Get your current user route
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getUsers = function (options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getUsers(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the Campaign by the requestId
     * @summary Get Campaign By request id Route
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getVideoRequestByRequestId = function (id, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getVideoRequestByRequestId(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns stats of the workspace
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getWorkspaceStats = function (workspaceId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getWorkspaceStats(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get the list of the current users workspaces
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getWorkspaces = function (options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getWorkspaces(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get workspace by id
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getWorkspacesId = function (id, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getWorkspacesId(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Optionally we can pass the userId, it will default to currentUser
     * @summary Get the current users workspace settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getWorkspacesSettings = function (options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getWorkspacesSettings(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get the legacy current users workspace usage.
     * @param {'all' | 'videos' | 'users'} usageType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getWorkspacesUsage = function (usageType, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getWorkspacesUsage(usageType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get the list of the assets
     * @param {string} workspaceId
     * @param {string} [folder]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getWorkspacesWorkspaceidAssets = function (workspaceId, folder, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getWorkspacesWorkspaceidAssets(workspaceId, folder, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns stats of the workspace
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getWorkspacesWorkspaceidCreatedvideos = function (workspaceId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getWorkspacesWorkspaceidCreatedvideos(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns stats of the workspace
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getWorkspacesWorkspaceidCreatedvideosv2 = function (workspaceId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getWorkspacesWorkspaceidCreatedvideosv2(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns stats of the workspace
     * @param {string} workspaceId
     * @param {number} usersNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getWorkspacesWorkspaceidTopvideosUsersnumber = function (workspaceId, usersNumber, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).getWorkspacesWorkspaceidTopvideosUsersnumber(workspaceId, usersNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a campaign By Id Route
     * @param {string} id
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchCampaignsId = function (id, body, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).patchCampaignsId(id, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Google login route
     * @summary Google Login Route
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchGoogleLogin = function (options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).patchGoogleLogin(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Add additional features to workspace by owners
     * @param {'storage' | 'workspaces' | 'videos' | 'creators'} feature
     * @param {'double'} value
     * @param {WorkspaceAdditionalFeaturesSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchWorkspacesAdditionalfeatures = function (feature, value, body, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).patchWorkspacesAdditionalfeatures(feature, value, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get workspace by id
     * @param {string} id
     * @param {Model10} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchWorkspacesId = function (id, body, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).patchWorkspacesId(id, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Replace the current users last visited workspace with the id provided.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchWorkspacesIdChange = function (id, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).patchWorkspacesIdChange(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Generate a valid JWT for our AppSumo intergration
     * @summary Returns a valid JWT for AppSumo intergration
     * @param {AppSumoLoginPayload} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postAppsumoAuthLogin = function (body, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).postAppsumoAuthLogin(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * When a Sumo-ling buys interacts with our license, we get a notification
     * @summary AppSumo notifications
     * @param {AppSumoNotificationPayload} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postAppsumoWebhookNotification = function (body, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).postAppsumoWebhookNotification(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create assets
     * @summary Create assets Route
     * @param {Model2} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postAssets = function (body, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).postAssets(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Forgot Password Route
     * @param {ForgotPasswordPayload} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postAuthForgotpassword = function (body, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).postAuthForgotpassword(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create Campaign in folder
     * @summary Create Campaign
     * @param {string} folderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postCampaign = function (folderId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).postCampaign(folderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a new Reaction to a Campaign Video
     * @summary Create a new Reaction
     * @param {string} campaignId
     * @param {CampaignReactionPayload} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postCampaignsCampaignidReactions = function (campaignId, body, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).postCampaignsCampaignidReactions(campaignId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the Campaign by the campaignId
     * @summary Duplicate Campaign
     * @param {string} campaignId
     * @param {Model5} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postCampaignsDuplicate = function (campaignId, body, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).postCampaignsDuplicate(campaignId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a new Campaign based on a Template
     * @summary Create a new Campaign based on a Template
     * @param {string} campaignId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postCampaignsUseTemplate = function (campaignId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).postCampaignsUseTemplate(campaignId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This receive an open object that containts the data we have to track
     * @summary Sendspark event to track user activity
     * @param {EventPayload} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postEvents = function (body, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).postEvents(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Google login route
     * @summary Google Login Route
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postGoogleLogin = function (options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).postGoogleLogin(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * User Login Route that returns a valid JTW
     * @summary Login Route
     * @param {LoginPayload} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postLogin = function (body, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).postLogin(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Being used for websockets to push events to the frontend.
     * @summary Webhook to get an event when an the asset is ready.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postMuxWebhookVideoready = function (options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).postMuxWebhookVideoready(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Request a new Video Campaign for the workspace passed as parameter
     * @summary Request Video Campaign
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postRequestCampaign = function (workspaceId, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).postRequestCampaign(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Add meeting links for the user passed as parameter
     * @summary Create meeting links for user
     * @param {string} userId
     * @param {UsersMeetingLinksPayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postUsersMeetingLinks = function (userId, body, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).postUsersMeetingLinks(userId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Optionally we can pass the userId, it will default to currentUser
     * @summary Create a new workspace
     * @param {CreateWorkspaceResponseSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postWorkspaces = function (body, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).postWorkspaces(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * We need pass the emails to invite to this route
     * @summary Workspace invite route
     * @param {string} workspaceId
     * @param {WorkspaceInvitePayload} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postWorkspacesWorkspaceidInvite = function (workspaceId, body, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).postWorkspacesWorkspaceidInvite(workspaceId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Completes the activation for appsumo packages.
     * @param {AppSumoActivationPayload} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.putAppsumoActivation = function (body, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).putAppsumoActivation(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update asset mime type
     * @summary Update mime type for an asset
     * @param {string} id
     * @param {Model9} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.putAssetsIdMime = function (id, body, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).putAssetsIdMime(id, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Google login route
     * @summary Google Login Route
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.putGoogleLogin = function (options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).putGoogleLogin(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a campaign By Request Id Route
     * @param {string} requestId
     * @param {VideoRequestPayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.putVideoRequestById = function (requestId, body, options) {
        var _this = this;
        return exports.DefaultApiFp(this.configuration).putVideoRequestById(requestId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DefaultApi;
}(base_1.BaseAPI));
exports.DefaultApi = DefaultApi;
